










































































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required, min, max } from 'vee-validate/dist/rules';
import Api from '../services/Api';

extend('required', required);
extend('max', max);
extend('min', min);

@Component({
  components: {
    ValidationObserver,
    ValidationProvider
  }
})
export default class Konfirmasi extends Vue {
  private data: any = {};
  private token: string = '';
  private tesBerakhir: boolean = false;
  private testBelumMulai: boolean = false;
  private mulaiDalam: string = '';
  spinner: boolean = false;
  private apiService: Api = new Api();

  constructor() {
    super();
  }

  get namanomor() {
    return this.data.nama + ' / ' + this.data.user;
  }
  get namakode() {
    return this.data.namamapel + ' / ' + this.data.mapel;
  }
  get alokasi() {
    return this.data.alokasi + ' menit';
  }

  created() {
    this.data = this.$route.params;
    if ( ! this.data.nama) {
      this.$router.replace({ name: 'Home' });
    }
    // auto token
    if (this.data.autotoken) {
      this.token = this.data.token;
    }
    // tes berakhir
    if (this.data.ttnow > this.data.ttend) {
      this.tesBerakhir = true;
    }
    // tes belum mulai
    if (this.data.ttnow < this.data.ttstart) {
      this.testBelumMulai = true;
      const time = this.data.ttstart - this.data.ttnow;
      if (time > 0) {
        this.countDownTime(time);
      }
    }
    // console.log(this.$route.params);
  }

  submit(): void {
    if (this.data.autotoken) {
      this.mulai();
    } else {
      this.spinner = true;
      this.apiService.getResource('/cektoken').then(r => {
        this.spinner = false;
        if (r.data.token == this.data.token) {
          this.mulai();
        } else {
          this.$toast.error('KODE TOKEN INVALID');
        }
      }).catch(err => {
        this.spinner = false;
        this.$toast.error('KODE TOKEN INVALID');
      }); 
    }
  }

  mulai(): void {
    this.spinner = true;
    this.apiService.postResource('/mulai', {
      username: this.data.user,
      mapel: this.data.mapel
    }, true).then(r => {
      this.spinner = false;
      const s = r.data.sisa;
      if (s == null || s < 0 || ! s) {
        this.$toast.error('WAKTU TES HABIS');
      } else {
        this.$router.replace({ name: 'Soal', params: { sisa: s, mapel: this.data.mapel } });
      }
    }).catch(err => {
      this.spinner = false;
      this.$toast.error(err.status + ' - ' + err.statusText);
    });
  }

  countDownTime(time: number): void {
    let start = time;
    let i = setInterval(() => {
      const distance = start * 1000;
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      let tampung = '';
      if (hours > 0) {
        tampung += (hours + '').padStart(2, '0') + ' JAM ';
      }
      if (minutes > 0) {
        tampung += (minutes + '').padStart(2, '0') + ' MENIT ';
      } else {
        tampung += ' 00 MENIT ';
      }
      if (seconds > 0) {
        tampung += (seconds + '').padStart(2, '0') + ' DETIK ';
      } else {
        tampung += ' 00 DETIK';
      }
      this.mulaiDalam = tampung;
      start -= 1;

      if (distance < 0) {
        this.testBelumMulai = false;
        clearInterval(i);
      }
    }, 1000);
  }
}
